<template>
  <div class="wing-layout">
    <div class="main-wrap">
      <div id="main-content">
        <div class="wrapper">
          <div class="table-agile-info">
            <jm-crumbs :crm_id="this.$route.params.crmid"/>
            <div class="pDetails-basic">
              <div class="basic-title"><em>基本信息</em></div>
              <el-row>
                <el-col :span="8">
                  <label>学生姓名：</label>
                  <el-input
                    class="jm-input280"
                    v-model="studentInfo.custom_name"
                    :disabled="hadStartSchool() || inProcess(this.currentProcess) || readonly"
                  />
                </el-col>
                <el-col :span="8">
                  <label>户籍所在：</label>
                  <jm-areaselect
                    v-model="domicile"
                    :disabled="hadStartSchool() || inProcess(this.currentProcess) || readonly"
                    @change="setArea"/>
                </el-col>
                <el-col :span="8">
                  <label>学历：</label>
                  <jm-education-select
                    v-model="education"
                    :disabled="hadStartSchool() || inProcess(this.currentProcess) || readonly"
                    @change="setEducation"/>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8"><label>家庭可支配收入：</label>
                  <el-input
                    class="jm-input280"
                    v-model="showMoneyType"
                    disabled
                  />
                </el-col>
                <el-col :span="8">
                  <label>电子协议：</label>
                  <el-button v-if="studentInfo['dzxy_file'] !== undefined && studentInfo['dzxy_file'] !== ''" size="small" type="primary" @click="downloadDzxy">
                    <i class="el-icon-document"></i>电子协议已上传
                  </el-button>
                  <el-button v-else type="primary" size="small" disabled>
                    未上传电子协议
                  </el-button>
                </el-col>
                <el-col :span="8">
                  <label>入学时间：</label>
                  <span>{{ shoolStartDate }}</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <label v-if="isQcrb">客服老师：</label>
                  <label v-else>文案老师：</label>
                  <span>{{ writer }}</span>
                </el-col>
                <el-col :span="8">
                  <label>当前状态：</label>
                  <span>
                    <b>{{ current_status }}</b>
                  </span>
                </el-col>
              </el-row>
            </div>
            <div
              v-if="!hadStartSchool() && !inProcess(this.currentProcess) && !readonly"
              class="pDetails-apply">
              <div class="basic-title"><em>申请学校</em></div>

              <el-row>
                <el-col :span="24">
                  <label>学校类型：</label>
                  <jm-dict-select
                    clearable
                    class="jm-input280"
                    v-model="country_sh_mg_id"
                    type="dataset"
                    dict-type="langschool_process"
                    name="JpSchoolType"/>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24">
                  <label>学校搜索：</label>
                  <jm-school-search
                    :country-sh-mg-id="country_sh_mg_id"
                    v-model="schoolModel"
                    clearable/>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <label>入学时间：</label>
                  <el-date-picker
                    class="jm-input280"
                    v-model="startDate"
                    type="month"
                    format="yyyy-MM"
                    :xpicker-options="starDateOpt"
                    placeholder="请选择"/>
                </el-col>
              </el-row>
              <el-row class="pDetails-apply-button" v-if="this.currentProcess ? this.currentProcess.is_delay_status_flag === 0 ? true : false : true">
                <el-col :span="24">
                  <el-button
                    type="primary"
                    @click="startProcess"
                    :disabled="!enableStart"
                    size="small">开始办理</el-button>
                </el-col>
              </el-row>
            </div>

            <div
              v-if="processList && processList.length > 0"
              class="pDetails-history-school">
              <div class="basic-title"><em>历史学校</em></div>
              <div class="pDetails-history-list">
                <el-collapse
                  v-model="activeName"
                  accordion>
                  <el-collapse-item
                    v-for="item in processList"
                    :key="item.id"
                    :name="`p_${item.id}`">
                    <template slot="title">
                      <el-tag type="danger" v-if="item.is_delay_status_flag === 1">未定</el-tag>
                      <span>申请学校：{{ item.schoolname }}<span v-if="item.prev_school"> - From：{{ item.prev_school }}</span></span>
                      <i
                        v-if="item.is_delay === 2 && item.delay_time && item.delay_time !== 'Invalid date'"
                        class="history-list-b">已延期至{{ formatStartDate(item.delay_time) }}</i>
                      <i
                        v-if="item.is_abort === 2"
                        class="history-list-b">在{{ getAbortDate(item.update_time) }}退办</i>
                      <i
                        v-if="item.is_start_school === 2"
                        class="history-list-b">在{{ getAbortDate(item.update_time) }}设置为已入学</i>
                      <div class="history-list-botton">
                        <div
                          v-if="item.is_delay === 1 && item.is_abort === 1 && item.is_start_school !== 2"
                          @click.stop>
                          <span v-if="!isQcrb">
                            <el-button
                              v-if="item.is_vip === 1"
                              type="primary"
                              @click="markVip"
                              size="small">随递随签</el-button>
                            <el-tag
                              v-else
                              size="big">已随签</el-tag>
                          </span>
                          <el-button
                            type="primary"
                            @click="startSchool"
                            size="small">入学</el-button>
                          <el-button
                            type="primary"
                            size="small"
                            @click="doTogglePopover('lockrSchool')"
                            slot="reference">转校</el-button>
                          <el-button
                            type="primary"
                            @click="doTogglePopover('lockrAbort')"
                            size="small">退办</el-button>
                          <el-button
                            type="primary"
                            size="small"
                            slot="reference"
                            @click="doTogglePopover('lockrDelay')">延期</el-button>
                        </div>
                        <div v-if="item.is_delay_status_flag === 1" @click.stop>
                          <el-button
                            type="primary"
                            size="small"
                            slot="reference"
                            @click="doTogglePopover('lockrDelay')">延期</el-button>
                        </div>
                        <div class="popover-wrap">
                          <el-dialog
                            placement="bottom-end"
                            :close-delay="500"
                            :visible.sync="lockrSchool"
                          >
                            <label>学校搜索：</label>
                            <jm-school-search
                              :country-id="83"
                              v-model="changedShoolModel"/>
                            <el-button
                              type="primary"
                              @click="changeSchool"
                              :disabled="!changedShoolModel">确定</el-button>
                          </el-dialog>
                          <el-dialog
                            placement="bottom-end"
                            :close-delay="500"
                            :visible.sync="lockrAbort"
                          >
                            <label>转案状态：</label>
                            <jm-dict-select
                              v-model="item.sub_status1"
                              class="jm-input175"
                              type="jiemo"
                              empty-value="0"
                              empty-label="请选择"
                              dict-type="jp_process_zhuanan"
                            />
                            <el-button
                              type="primary"
                              :disabled="!item.sub_status1"
                              @click.stop="abortProcess">确定</el-button>
                          </el-dialog>
                          <el-dialog
                            :close-delay="500"
                            placement="bottom-end"
                            :visible.sync="lockrDelay"
                          >
                            <label>转案状态：</label>
                            <jm-dict-select
                              v-model="item.sub_status1"
                              class="jm-input175"
                              type="jiemo"
                              empty-value="0"
                              empty-label="请选择"
                              dict-type="jp_process_zhuanan"
                            />
                            <label>延期至：</label>
                            <el-date-picker
                              class="jm-input135"
                              v-model="item.delay_time"
                              type="month"
                              format="yyyy-MM"
                              :picker-options="delayDateOpt"
                              :default-value="startDate"
                              placeholder="请选择"/>
                            <el-button
                              type="primary"
                              @click="delayProcess"
                              :disabled="(!item.delay_time && !item.is_delay_status === true) || ['0', ''].indexOf(item.sub_status1) !== -1">确定</el-button>
                            <el-row>
                              <el-col :span="12">
                                <el-checkbox :checked="item.is_delay_status_flag === 1" v-model="item.is_delay_status">延期未定</el-checkbox>
                              </el-col>
                            </el-row>
                          </el-dialog>
                        </div>
                      </div>
                    </template>
                    <div class="history-list-content">
                      <el-row class="pDetails-apply-button-cloud">
                        <el-col :span="12">
                          <label>是否沟通老师：</label>
                          <el-select
                            :disabled="!inProcess(item)"
                            class="jm-input175"
                            v-model="item.had_write_teacher"
                            placeholder="请选择">
                            <el-option
                              v-for="item in teacherOptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"/>
                          </el-select>
                        </el-col>
                        <el-col
                          v-if="inProcess(item)"
                          :span="12">
                          <label style="width: auto">材料进度：</label>
                          <el-progress
                            :text-inside="true"
                            :stroke-width="18"
                            :percentage="item.process"/>
                          <el-tag
                            type="danger"
                            v-if="!item.crm_userid">该用户非注册用户无法查看云盘</el-tag>
                          <router-link
                            v-else
                            :to="{ name: isQcrb ? 'qcrb_cloudDisk' : 'cloudDisk', params: { id: item.crm_id } }">
                            <el-button
                              type="primary"
                              size="small">进入材料云盘</el-button>
                          </router-link>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col
                          :span="12"
                          v-if="current_status === '申请中'">
                          <label>申请状态：</label>
                          <jm-dict-select
                            v-model="item.sub_status"
                            class="jm-input175"
                            type="dataset"
                            dict-type="langschool_process"
                            name="processSubState"
                          />
                        </el-col>
                        <el-col
                          :span="12"
                        >
                          <label>在留下达放弃：</label>
                          <jm-dict-select
                            v-model="item.is_abandon"
                            class="jm-input175"
                            type="dataset"
                            dict-type="langschool_process"
                            name="booleanOptions"
                          />
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="12">
                          <label>原件接收：</label>
                          <el-select
                            :disabled="!inProcess(item)"
                            class="jm-input175"
                            v-model="item.recive_origin"
                            placeholder="请选择">
                            <el-option
                              v-for="item in booleanOptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"/>
                          </el-select>
                          &nbsp;
                          <el-button type="warning" size="small" v-if="item.recive_origin === 2" @click="dialogTableVisible = true">详细原件</el-button>
                          <el-dialog
                            title="请选择已接受的原件"
                            :visible.sync="dialogTableVisible "
                            width="30%"
                            center>
                            <el-form :model="item.checkLists">
                              <el-form-item label="选项" :label-width="formLabelWidth">
                                <el-checkbox-group v-model="item.checkList">
                                  <el-checkbox
                                    style="text-align:left;margin-left: 14px;"
                                    @change="item.recive_origin_diploma === 1?item.recive_origin_diploma = 0:item.recive_origin_diploma = 1"
                                    :checked="item.recive_origin_diploma === 1"
                                    v-model="item.recive_origin_diploma"
                                    label="毕业证书"></el-checkbox>
                                  <el-checkbox
                                    style="text-align:left;"
                                    @change="item.recive_origin_graduate_diploma === 1?item.recive_origin_graduate_diploma = 0:item.recive_origin_graduate_diploma = 1"
                                    :checked="item.recive_origin_graduate_diploma === 1"
                                    v-model="item.recive_origin_graduate_diploma"
                                    label="学位证" ></el-checkbox>
                                  <el-checkbox
                                    style="text-align:left;"
                                    @change="item.recive_origin_certificate_japanese === 1?item.recive_origin_certificate_japanese = 0:item.recive_origin_certificate_japanese = 1"
                                    :checked="item.recive_origin_certificate_japanese === 1"
                                    v-model="item.recive_origin_certificate_japanese"
                                    label="日语证书" ></el-checkbox>
                                  <el-checkbox
                                    style="text-align:left;"
                                    @change="item.recive_origin_seal === 1?item.recive_origin_seal = 0:item.recive_origin_seal = 1"
                                    :checked="item.recive_origin_seal === 1"
                                    v-model="item.recive_origin_seal"
                                    label="印章" ></el-checkbox>
                                  <el-checkbox
                                    style="text-align:left;"
                                    @change="item.recive_origin_notarization === 1?item.recive_origin_notarization = 0:item.recive_origin_notarization = 1"
                                    :checked="item.recive_origin_notarization === 1"
                                    v-model="item.recive_origin_notarization"
                                    label="公证书" ></el-checkbox>
                                  <el-checkbox
                                    style="text-align:left;"
                                    @change="item.recive_origin_certificate_deposit === 1?item.recive_origin_certificate_deposit = 0:item.recive_origin_certificate_deposit = 1"
                                    :checked="item.recive_origin_certificate_deposit === 1"
                                    v-model="item.recive_origin_certificate_deposit"
                                    label="存款证明"></el-checkbox>
                                  <el-checkbox
                                    style="text-align:left;"
                                    @change="item.recive_origin_photo === 1?item.recive_origin_photo = 0:item.recive_origin_photo = 1"
                                    :checked="item.recive_origin_photo === 1"
                                    v-model="item.recive_origin_photo"
                                    label="照片" ></el-checkbox>
                                </el-checkbox-group>
                              </el-form-item>

                              <el-form-item label="备注" :label-width="formLabelWidth">
                                <el-input type="textarea" style="width:100%" v-model="item.recive_origin_comment"></el-input>
                              </el-form-item>
                            </el-form>
                            <span slot="footer" class="dialog-footer">
                              <el-button @click="dialogTableVisible = false">取 消</el-button>
                              <el-button type="primary" @click="dialogTableVisible = false;saveProcess(currentProcess)">确 定</el-button>
                            </span>
                          </el-dialog>
                        </el-col>
                        <el-col :span="12">
                          <label>材料原件提交学校：</label>
                          <el-select
                            :disabled="!$hasPermission([58, 76, 19]) || !inProcess(item)"
                            class="jm-input175"
                            v-model="item.send_school"
                            placeholder="请选择">
                            <el-option
                              v-for="item in booleanOptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"/>
                          </el-select>
                          &nbsp;
                          <el-button type="warning" size="small" @click="centerDialogVisible = true" v-if="item.send_school === 2">快递单号</el-button>
                          <el-dialog
                            title="请填写运单号"
                            :visible.sync="centerDialogVisible"
                            width="30%"
                            center>
                            <el-form :model="item.send_school_tracking_number">
                              <el-form-item
                                :label-width="formLabelWidth"
                                v-for="(tracking, index) in item.send_school_tracking_number1"
                                :label="'快递单号'"
                                :key="tracking.key"
                                :prop="'tracking.' + index + '.value'"
                              >
                                <el-input v-model="tracking.value" style="width:75%"></el-input>
                                <el-button @click.prevent="removeTracking(tracking, item.send_school_tracking_number1)">删除</el-button>
                              </el-form-item>
                              <el-upload
                                :disabled="!inProcess(item)"
                                :action="uploadFile"
                                :on-remove="handleRemoveMulti"
                                :file-list="item.send_school_photo"
                                :data="{
                                  field: 'send_school_photo',
                                }"
                                :limit="10"
                                :headers="headers"
                                :on-success="setPortraitMulti"
                                list-type="picture-card">
                                <el-button size="small" type="primary">上传图片</el-button>
                              </el-upload>
                            </el-form>
                            <span slot="footer" class="dialog-footer">
                              <el-button @click="addTracking(item.send_school_tracking_number1)">新增快递单号</el-button>
                              <el-button @click="centerDialogVisible = false">取 消</el-button>
                              <el-button type="primary" @click="centerDialogVisible = false;saveProcess(currentProcess)">确 定</el-button>
                            </span>
                          </el-dialog>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="12">
                          <label v-if="isQcrb">内部终审：</label>
                          <label v-else>芥末网内部终审：</label>
                          <el-select
                            :disabled="!$hasPermission([58, 76]) || !inProcess(item)"
                            class="jm-input175"
                            v-model="item.status"
                            placeholder="请选择">
                            <el-option
                              v-for="item in booleanOptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"/>
                          </el-select>
                        </el-col>
                        <el-col :span="12">
                          <label>提交入管局：</label>
                          <el-select
                            :disabled="!$hasPermission([58, 76]) || !inProcess(item)"
                            class="jm-input175"
                            v-model="item.submit_org"
                            placeholder="请选择">
                            <el-option
                              v-for="item in submitOrgOptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"/>
                          </el-select>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="12">
                          <label>在留申请结果：</label>
                          <el-select
                            :disabled="!$hasPermission([19, 58, 75, 76]) || !inProcess(item)"
                            class="jm-input175"
                            v-model="item.zailiu"
                            placeholder="请选择">
                            <el-option
                              v-for="item in deliverState"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"/>
                          </el-select>
                        </el-col>
                        <el-col :span="12">
                          <label>当期生：</label>
                          <el-select
                            :disabled="!inProcess(item)"
                            class="jm-input175"
                            v-model="item.is_current"
                            placeholder="请选择">
                            <el-option
                              v-for="item in booleanOptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"/>
                          </el-select>
                        </el-col>
                      </el-row>
                      <el-row v-show="!isQcrb">
                        <el-col :span="12">
                          <label>是否赴日：</label>
                          <jm-dict-select
                            v-model="item.is_gone_japan"
                            class="jm-input175"
                            type="jiemo"
                            value-type="String"
                            dict-type="jp_process_gone_japan"
                          />
                        </el-col>
                        <el-col :span="12">
                          <label>是否缴纳学费：</label>
                          <jm-dict-select
                            v-model="item.is_pay_study"
                            class="jm-input175"
                            type="jiemo"
                            value-type="String"
                            dict-type="jp_process_pay_study"
                          />
                        </el-col>
                      </el-row>
                      <el-row v-show="!isQcrb">
                        <el-col :span="12">
                          <label>赴日意向：</label>
                          <jm-dict-select
                            v-model="item.purpose_level"
                            class="jm-input175"
                            type="jiemo"
                            value-type="String"
                            dict-type="jp_process_purpose_level"
                          />
                        </el-col>
                        <el-col :span="12">
                          <label>签证递签状态：</label>
                          <jm-dict-select
                            v-model="item.sign_status"
                            class="jm-input175"
                            type="jiemo"
                            value-type="String"
                            dict-type="jp_process_sign_status"
                          />
                        </el-col>
                      </el-row>
                      <el-row v-show="!isQcrb">
                        <el-col :span="12">
                          <label><i v-show="item.sign_status === '3'" style="color: red">*</i>递签日期：</label>
                          <el-date-picker
                            v-model="item.sign_date"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期"/>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="24">
                          <label>备注：</label>
                          <el-input
                            :disabled="!inProcess(item)"
                            type="textarea"
                            :rows="2"
                            placeholder="请输入内容"
                            v-model="item.memo"/>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="12">
                          <label class="fileupload">签证页：</label>
                          <el-upload
                            :disabled="!inProcess(item)"
                            :action="uploadFile"
                            :on-remove="handleRemove"
                            :file-list="item.visa_img_url"
                            :data="{
                              field: 'visa_img_url',
                            }"
                            :limit="1"
                            :headers="headers"
                            :on-success="setPortrait"
                            list-type="picture-card">
                            <el-button size="small" type="primary">上传图片</el-button>
                          </el-upload>
                          <el-button style="margin:-10px 0 0 138px" v-show="item.visa_img_url.length > 0" type="text" @click="viewImgClick(item.visa_img_url)">预览已上传图片</el-button>
                        </el-col>
                        <el-col :span="12">
                          <label class="fileupload">汇款底单：</label>
                          <el-upload
                            :disabled="!inProcess(item)"
                            :action="uploadFile"
                            :on-remove="handleRemove"
                            :file-list="item.remitting_img_url"
                            :data="{
                              field: 'remitting_img_url',
                            }"
                            :limit="1"
                            :headers="headers"
                            :on-success="setPortrait"
                            list-type="picture-card">
                            <el-button size="small" type="primary">上传图片</el-button>
                          </el-upload>
                          <el-button style="margin:-10px 0 0 138px" v-show="item.remitting_img_url.length > 0" type="text" @click="viewImgClick(item.remitting_img_url)">预览已上传图片</el-button>
                        </el-col>
                        <el-dialog title="图片预览" width="1200px" :visible.sync="viewImgLock">
                          <el-carousel trigger="click" height="500px">
                            <el-carousel-item v-for="item in viewImgList" :key="item.url" style="overflow-y: auto">
                              <img :src="item.url" width="100%" alt="">
                            </el-carousel-item>
                          </el-carousel>
                        </el-dialog>
                      </el-row>
                      <el-row>
                        <el-col :span="24">
                          <label/>
                          <el-button
                            type="primary"
                            v-if="inProcess(item)"
                            size="small"
                            @click="saveProcess(currentProcess)">
                            确定修改
                          </el-button>
                          <!-- <el-button
                            type="warning"
                            size="small">
                            <a
                              target="_blank"
                              :href="`/system.php/CopyWriteJp/see_old_operator/crm_id/${item.crm_id}/table_id/${item.school_id}`">操作记录</a>
                          </el-button> -->
                        </el-col>
                      </el-row>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import * as moment from 'moment';
import writeProcess from './process.js';
import { messageBox } from '@/utils/messagebox';
import * as UserApi from '@/api/user.js';
import * as TeacherApi from '@/api/teacher.js';
import { crumbs, jmSchoolSearch, jmAreaselect, jmEducationSelect, jmDictSelect } from '@/components/tool/index.js';
import {
  formatCustomYear,
  formatCustomMonth,
} from '@/utils/utils.js';
import { currentInterviewSchool } from '@/api/user';

export default {
  mixins: [writeProcess],
  data() {
    return {
      crmId: null,
      startDate: '',
      country_sh_mg_id: 238, // 默认语言学校
      schoolModel: {},
      domicile: [],
      changedShoolModel: null, // 转校
      processList: null, // 流程列表
      currentProcess: {}, // 当前流程数据
      delayDate: null, // 延期时间
      starDateOpt: {
        disabledDate(time) {
          if (this.$hasPermission(1)) {
            return true;
          }
          return (time.getMonth() % 3) !== 0 || (time.getFullYear() < (new Date()).getFullYear());
        }
      },
      activeName: '',
      education: [], // 学历
      writer: null, // 文案
      studentInfo: {
        money: 0,
        custom_year: '',
        custom_month: '',
      },
      uploadFile: '/newfib.php/index/jp_process/uploadFile',
      uploadList: {},
      dialogTableVisible: false,
      centerDialogVisible: false,
      formLabelWidth: '80px',
      trackingNumber: [{
        value: ''
      }],
      lockrDelay: false,
      lockrSchool: false,
      lockrAbort: false,
      viewImgLock: false,
      viewImgList: []
    };
  },
  components: {
    'jm-crumbs': crumbs, // 面包屑
    jmSchoolSearch,
    jmAreaselect,
    jmEducationSelect,
    jmDictSelect,
  },
  beforeCreate() {
    UserApi.getBaseInfo(this.$route.params.crmid).then(({ data }) => {
      this.studentInfo = Object.assign(this.studentInfo, data);
      this.domicile = [
        data.custom_place_area,
        data.custom_place_city
      ];
      this.education = [
        data.custom_education,
        data.custom_detail
      ];
      this.initWriteTeacher();
      this.startDate = moment(this.shoolStartDate, 'YYYY年MM月').format('YYYY-MM-DD');
    });
  },
  created() {
    this.crmId = this.$route.params.crmid;
    /*
    * 初始化数据
    * */
    this.getProcesses();
    currentInterviewSchool(this.crmId).then(({ data }) => {
      this.schoolModel = {
        sh_id: data.school_id,
        sh_name_cn: data.school_name,
        sh_name_en: data.school_name_en,
        sh_mg_id: data.school_mg_id,
        value: data.school_name,
      };
    });
  },
  computed: {
    delayDateOpt() {
      const year = this.studentInfo.custom_year;
      const month = this.studentInfo.custom_month;
      return {
        disabledDate(time) {
          return (time.getFullYear() <= year && time.getMonth() <= month)
            || ((time.getMonth() % 3) !== 0 || (time.getFullYear() < (new Date()).getFullYear()));
        }
      };
    },
    /*
    * 开始办理 按钮是否显示可点击
    * */
    enableStart() {
      return !_.isEmpty(this.schoolModel)
       && this.startDate
       && this.writer
       && this.domicile[1]
       && this.studentInfo.custom_name
       // && this.studentInfo.dzxy_file
       && this.studentInfo.custom_detail
       && this.studentInfo.custom_education;
    },
    shoolStartDate() {
      if (this.studentInfo.custom_year && this.studentInfo.custom_month) {
        const startDate = moment()
          .set({ year: this.studentInfo.custom_year, month: this.studentInfo.custom_month - 1 });
        return startDate.format('YYYY年MM月');
      }
      if (this.studentInfo.custom_year && !this.studentInfo.custom_month) {
        return `${this.studentInfo.custom_year}年`;
      }
      return '';
    },
    showMoneyType () {
      switch (this.studentInfo.money) {
        case 0:
          return '未选择';
        case 1:
          return '0-50万';
        case 2:
          return '50-100万';
        case 3:
          return '100-200万';
        case 4:
          return '200万以上';
        default:
          return this.studentInfo.money;
      }
    },
    readonly() {
      return !this.$hasPermission([75, 76, 19, 33, 58]);
    },
    /**
     * 当前状态
     *
     * @author Cong Peijun <congpeijun@jiemo.net>
     * @return {String}
     */
    current_status() {
      if (!this.currentProcess) {
        return '未开始';
      }

      if (this.currentProcess.is_abort === 2) {
        return '已退办';
      }

      if (this.currentProcess.is_delay === 2) {
        return '延期中';
      }

      if (this.currentProcess.is_start_school === 2) {
        return '已入学';
      }
      return this.currentProcess ? '申请中' : '';
    },
    headers() {
      return {
        'x-site-name': process.env.VUE_APP_SITE_NAME || 'fib',
        'x-jwt-token': this.$lockr.get('jwt', null),
      };
    },
  },
  methods: {
    viewImgClick(item) {
      this.viewImgLock = true;
      this.viewImgList = item;
    },
    /**
     * 获取文案老师
     *
     * @author Cong Peijun <congpeijun@jiemo.net>
     */
    initWriteTeacher() {
      if (this.isQcrb) { // 前程日本获取语言学校客服老师
        TeacherApi.getCseTeachers().then(({ data }) => {
          const teacher = _.find(data, { userid: this.studentInfo.crm_cse });
          if (teacher) {
            this.writer = teacher.truename;
          }
        });
        return true;
      }
      this.getWriteTeachers().then((response) => {
        const teacher = _.find(response.data, { userid: this.studentInfo.crm_writer });
        if (teacher) {
          this.writer = teacher.truename;
        }
      });
    },
    /**
     * 延期
     */
    delayProcess() {
      messageBox.msgBox({
        message: '确定要延期?',
      }).then(() => {
        this.currentProcess.is_delay = 2;
        this.updateUserStartTime(this.currentProcess.delay_time);
        this.currentProcess.delay_time = moment(this.currentProcess.delay_time).format('YYYY-MM-DD');
        this.lockrDelay = false;
        this.saveProcess(this.currentProcess).then(() => {
          window.location.reload();
        });
      }).catch(() => {
        this.$message.info('已取延期');
      });
    },
    /**
     * 转校
     *
     * @author Cong Peijun <congpeijun@jiemo.net>
     */
    changeSchool() {
      messageBox.msgBox({
        message: '确定要转校?',
      }).then(() => {
        if (this.changedShoolModel) {
          this.currentProcess.prev_school = this.currentProcess.schoolname;
          this.currentProcess.schoolInfo = this.changedShoolModel;
          this.currentProcess.schoolname = this.changedShoolModel.sh_name_cn;
        }
        this.lockrSchool = false;
        this.saveProcess(this.currentProcess).catch(() => {
          this.currentProcess.schoolname = this.currentProcess.prev_school;
        });
      }).catch(() => {
        this.$message.info('已取转校');
      });
    },
    /**
     * 终止流程
     *
     * @author Cong Peijun <congpeijun@jiemo.net>
     */
    abortProcess() {
      messageBox.msgBox({
        message: '确定要终止办理?',
      }).then(() => {
        this.currentProcess.is_abort = 2;
        this.saveProcess(this.currentProcess);
        this.lockrAbort = false;
      }).catch(() => {
        this.$message.info('已取终止办理');
      });
    },
    /**
     * 入学
     *
     * @author Cong Peijun <congpeijun@jiemo.net>
     */
    startSchool() {
      // 入学前置条件- 必须上传 签证页+汇款底单
      if (this.currentProcess.visa_img_url.length === 0) {
        messageBox.msgBox({ message: '请上传签证页图片' });
        return false;
      }
      if (this.currentProcess.remitting_img_url.length === 0) {
        messageBox.msgBox({ message: '请上传汇款底单图片' });
        return false;
      }
      messageBox.msgBox({ message: '该学生是否已入学' }).then(() => {
        this.currentProcess.is_start_school = 2;
        this.saveProcess(this.currentProcess);
      }).catch(() => {
      });
    },
    /**
     * 获取流程列表
     *
     * @author Cong Peijun <congpeijun@jiemo.net>
     */
    getProcesses() {
      return this.$http._get({
        url: `/index/jp_process/getProcesses/crmid/${this.crmId}`
      }).then((response) => {
        this.processList = response.data || [];
        this.currentProcess = _.last(this.processList);
        if (this.currentProcess) {
          if (this.currentProcess.delay_time === '0000-00-00') {
            this.currentProcess.delay_time = '';
          }
          this.activeName = `p_${this.currentProcess.id}`;
        }
      });
    },
    /**
     * 开始流程
     *
     * @author Cong Peijun <congpeijun@jiemo.net>
     */
    startProcess() {
      messageBox.msgBox({
        message: '确定要开始办理?',
      }).then(() => {
        this.$http._post({
          url: '/index/jp_process/start',
          data: {
            crmid: this.$route.params.crmid,
            country_sh_mg_id: this.country_sh_mg_id,
            school: this.schoolModel,
            startDate: this.startDate,
            studentInfo: this.studentInfo,
            qcrb: this.isQcrb,
          }
        }).then((response) => {
          this.currentProcess = response.data;
          this.activeName = `p_${this.currentProcess.id}`;
          this.updateUserStartTime(this.startDate);
          this.getProcesses();
        });
      }).catch(() => {
        this.$message.info('已取办理');
      });
    },
    /**
     * 延期时间格式化
     */
    updateUserStartTime(startDate) {
      this.studentInfo.custom_year = formatCustomYear(startDate);
      this.studentInfo.custom_month = formatCustomMonth(startDate);
    },
    /**
     * 返回时间
     */
    getAbortDate(timestmap) {
      return timestmap;
    },
    /**
     * 格式化入学时间
     *
     * @author Cong Peijun <congpeijun@jiemo.net>
     * @param  {String} date
     * @return {String}
     */
    formatStartDate(date) {
      if (date) {
        return moment(date).format('YYYY年MM月');
      }
      return '';
    },
    /**
     * 转校 延期 空白关闭
     */
    doTogglePopover(key) {
      this[key] = true;
    },
    /**
     * 户籍所在
     */
    setArea(val) {
      this.$set(this.studentInfo, 'custom_place_area', val[0]);
      this.$set(this.studentInfo, 'custom_place_city', val[1]);
    },
    /**
     * 学历
     */
    setEducation(val) {
      this.$set(this.studentInfo, 'custom_education', val[0]);
      this.$set(this.studentInfo, 'custom_detail', val[1]);
    },
    /**
     * 下载电子协议
     */
    downloadDzxy() {
      window.open(this.$jiemo.imghome + this.studentInfo.dzxy_file);
    },
    hadStartSchool() {
      return this.currentProcess && this.currentProcess.is_start_school === 2;
    },
    markVip() {
      messageBox.msgBox({ message: '是否将该学生设置为随递随签' }).then(() => {
        this.currentProcess.had_write_teacher = 2;
        this.currentProcess.recive_origin = 2;
        this.currentProcess.process = 100;
        this.currentProcess.status = 2;
        this.currentProcess.send_school = 2;
        this.currentProcess.is_vip = 2;
        this.saveProcess(this.currentProcess);
      }).catch(() => {
      });
    },
    setPortrait(res) {
      this.currentProcess[res.data[0].field] = res.data;
    },
    setPortraitMulti(res) {
      this.currentProcess[res.data[0].field].push(res.data[0]);
    },
    handleRemove(file) {
      if (this.currentProcess.visa_img_url[0].url === file.url) {
        this.currentProcess.visa_img_url.splice(0, 1);
      }
      if (this.currentProcess.remitting_img_url[0].url === file.url) {
        this.currentProcess.remitting_img_url.splice(0, 1);
      }
    },
    handleRemoveMulti(file) {
      for (let i = this.currentProcess.send_school_photo.length - 1; i >= 0; i--) {
        if (this.currentProcess.send_school_photo[i].url === file.url) {
          this.currentProcess.send_school_photo.splice(i, 1);
        }
      }
    },
    removeTracking(item, data) {
      let index = data.indexOf(item);
      if (index !== -1) {
        data.splice(index, 1);
      }
    },
    addTracking(data) {
      return data.push({
        value: '',
        key: Date.now()
      });
    }
  }
};
</script>
<style scoped>
  .pDetails-basic{
    margin: 10px 8px 15px;
  }
  .pDetails-basic .el-row{
    margin-bottom: 10px;
  }
  .pDetails-basic .basic-title{
    margin: 0 0 10px 0;
  }
  .pDetails-basic .basic-m1{
    margin-bottom: 10px;
  }
  .pDetails-basic span{
    margin-right: 20px;
  }
  .pDetails-basic span b{
    color: #f00;
  }
  .pDetails-apply .el-row {
    margin-bottom: 10px;
  }
  .pDetails-apply-button .el-button{
    margin-left: 75px;
  }
  .pDetails-apply-button-cloud .el-button{
    display: inline-block;
    margin-left: 15px;
  }
  .history-list-b,
  .history-list-botton{
    display: block;
    color: #333;
    float: right;
    margin-right: 10px;
    margin-left: 10px;
  }
  .history-list-botton .el-button{
    margin-left: 10px;
  }
  .pDetails-history-list .history-list-content{
    padding:15px 10px;
  }
  .pDetails-history-list .el-collapse-item__content .el-row{
    margin-bottom: 10px;
  }
  .pDetails-history-list .el-collapse-item__content label{
    text-align: right;
    display: inline-block;
    width: 140px;
    font-size: 14px;
  }
  .pDetails-history-list .el-progress{
    width: 30%;
    display: inline-block;
  }
  .pDetails-history-list .el-textarea{
    width: 60%;
  }
  .history-list-none .history-list-content{
    display: none;
  }
  .fileupload{
    float: left;
  }
</style>
<style>
  .history-list-none .el-collapse-item__wrap{
    border: 0 !important;
  }
</style>
